import styled, { css } from "styled-components";
import { Image } from "cloudinary-react";

const disablePrinting = css`
  @media print {
    display: none;
  }
`;

export const LargeThankYouCampaignImage = styled.img`
  width: 100%;
  margin-bottom: 10px;

  @media screen and (max-width: 480px) {
    display: none;
  }
  ${disablePrinting}
`;

export const SmallThankYouCampaignImage = styled.img`
  width: 100%;
  margin-bottom: 10px;

  @media screen and (min-width: 481px) {
    display: none;
  }
  ${disablePrinting}
`;

export const LargeSponsorCampaignImage = styled(LargeThankYouCampaignImage).attrs({
  as: Image,
})`
  ${disablePrinting}
`;

export const SmallSponsorCampaignImage = styled(SmallThankYouCampaignImage).attrs({
  as: Image,
})`
  ${disablePrinting}
`;

